export default "__VITE_ASSET__Brp8hl1N__";